import { render, staticRenderFns } from "./VRPDF.vue?vue&type=template&id=73472e33&scoped=true"
import script from "./VRPDF.vue?vue&type=script&lang=js"
export * from "./VRPDF.vue?vue&type=script&lang=js"
import style0 from "./VRPDF.vue?vue&type=style&index=0&id=73472e33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73472e33",
  null
  
)

export default component.exports